import { useRef, useEffect, useState } from "react";

export const REPORT_CONTENT_HEIGHT = 775;

export const useDynamicWrappingPages = (blocks) => {
  const [pageBlocks, setPageBlocks] = useState([]);
  const blocksRef = useRef([]);

  const setRefElement = (element, idx) => {
    blocksRef.current[idx] = element;
  };

  useEffect(() => {
    const buildPageBlocksArray = () => {
      const heights = blocksRef.current.map((ref) => ref?.offsetHeight);
      const heightSum = heights.reduce((sum, height) => sum + height, 0);

      if (heightSum < REPORT_CONTENT_HEIGHT) {
        return setPageBlocks([blocks]);
      }

      let pageIdx = 0;
      let pageBlockHeight = 0;
      let pageBlocks = [[]];

      heights.forEach((height, idx) => {
        if (pageBlockHeight + height < REPORT_CONTENT_HEIGHT) {
          pageBlockHeight += height;
          return pageBlocks[pageIdx].push(blocks[idx]);
        }
        pageBlockHeight = 0;
        pageIdx++;
        pageBlockHeight += height;
        pageBlocks.push([]);
        return pageBlocks[pageIdx].push(blocks[idx]);
      });

      return setPageBlocks(pageBlocks);
    };

    if (blocksRef.current.length > 0 && !pageBlocks.length) {
      buildPageBlocksArray();
    }
  }, [blocks, pageBlocks.length]);

  return { pageBlocks, setRefElement };
};
